
import { defineComponent } from "vue";
import CreateEditDialog from "@/components/controls/catalogueGrid/CreateEditDialog.vue";
import mountComponentMixin from "@/mixins/MountComponentMixin";
import { DxCheckBox } from "devextreme-vue/check-box";
import TextControl from "@/components/controls/base/TextControl.vue";
import IntegerControl from "@/components/controls/base/IntegerControl.vue";
import {
  ImportColumnType,
  FeatureType,
} from "@/components/catalogues/FeatureCatalogue/FeatureType";
import CatalogueSelectControl from "@/components/controls/base/CatalogueSelectControl.vue";
import EnumControl from "@/components/controls/base/EnumControl.vue";

export default defineComponent({
  components: {
    CreateEditDialog,
    TextControl,
    DxCheckBox,
    IntegerControl,
    CatalogueSelectControl,
    EnumControl,
  },
  mixins: [mountComponentMixin],
  props: {
    saveModelCallback: { required: true },
  },
  computed: {
    isProperty() {
      return this.createEditModel.columnType == ImportColumnType.Property;
    },
    isField() {
      return this.createEditModel.columnType == ImportColumnType.Field;
    },
  },
  watch: {},
  methods: {
    onIsBooleanTrueAnyNotEmptyValueChanged(value: any) {
      if (value) {
        this.createEditModel.booleanTrueValue = "";
      }
    },
    dialog() {
      return this.$refs.dialog as any;
    },
    open(model: any, editType: any) {
      this.dialog().open(model, editType);
      this.createEditModel = this.dialog().createEditModel;
      this.controlType = null;
    },
    close() {
      this.dialog().close();
    },
    save() {
      this.dialog().save();
    },
  },
  data() {
    return {
      createEditModel: {},
      controlType: FeatureType.String,
      catalogueId: null,
      enumId: null,
      dCatalogueId: null,
      controlDescription: null,
      cataloguePath: null,
      enumType: null,
      dCatalogueModel: null,
    };
  },
});
